import { Repository } from "src/firebase/firestore/repository";
import { UserBlocks } from "../types/user-blocks.entity";

export const USER_BLOCKS_COLLECTION = "user_blocks";

export class UserBlocksRepository extends Repository<UserBlocks> {
  constructor() {
    super(USER_BLOCKS_COLLECTION);
  }
}

export const userBlocksRepository = new UserBlocksRepository();
